// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed12e6fd","455":"1e3a2823"}[chunkId] + ".chunk.js";
};